import { useContext } from 'react';
import AuthContext from '../contexts/AccessTokenContext';

const useAuth = () => useContext(AuthContext);

export default useAuth;
